module.exports = __webpack_public_path__ + "1f1699b93072bf178d33cba3253d5bb6.svg";